const _tableImport = {
    excleHead: [
        // status
        {
            title: "Status Import",
            dataIndex: "status_import",
            scopedSlots: { customRender: "status_import" },
            width: 100,
            // fixed: "left",
            className: "center-colum column-header-fix-data-s",
        },
        // status detail
        {
            title: "Status Import Detail",
            dataIndex: "status_detail",
            scopedSlots: { customRender: "status_detail" },
            width: 150,
            // fixed: "left",
            className: "center-colum column-header-fix-data-s",
        },        
        {
            title: "Student_ID",
            dataIndex: "student_id",
            key: "student_id",
            width: 80,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Name Of University",
            dataIndex: "university_name",
            scopedSlots: { customRender: "university_name" },
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Major",
            dataIndex: "major",
            scopedSlots: { customRender: "major" },
            // fixed: "left",
            width: 150,
            className: "center-colum column-header-fix-data",
        },{
            title: "Degree",
            dataIndex: "type_graduate",
            width: 100,
            scopedSlots: { customRender: "type_graduate" },
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Country",
            dataIndex: "country",
            width: 100,
            scopedSlots: { customRender: "country" },
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
    ],
}

export default _tableImport;
